export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-gradient-to-br from-primary-50/50 via-background-50 to-accent-50/30 rounded-xl border border-background-200/70 p-6 md:p-10">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">立即下载91影视看片app</h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              支持安卓版与苹果iOS版，最新版本安装包免费下载。兼容主流手机型号，随时随地高清看片不缓冲，畅享免费影视在线观看体验。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mb-6">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium whitespace-nowrap rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all cursor-pointer no-underline"
              >
                <i className="ri-android-line text-base"></i>安卓版下载
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium whitespace-nowrap rounded-full border border-foreground-200 text-foreground-700 hover:bg-background-100 transition-all cursor-pointer no-underline"
              >
                <i className="ri-apple-line text-base"></i>苹果版下载
              </a>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs text-foreground-400">
              <span className="flex items-center gap-1">
                <i className="ri-shield-check-line"></i>安全认证
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-smartphone-line"></i>兼容主流机型
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-download-cloud-2-line"></i>最新版本 v3.8.2
              </span>
            </div>
          </div>

          <div className="flex-1 flex justify-center">
            <div className="relative w-[240px] h-[440px] md:w-[280px] md:h-[480px]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20a%20sleek%20movie%20app%20download%20page%20with%20download%20button%20highlighted%2C%20showing%20app%20icon%20and%20version%20info%2C%20dark%20theme%20UI%20with%20warm%20amber%20accents%2C%20minimalist%20design%2C%20soft%20lighting%2C%20isolated%20on%20clean%20background&width=560&height=960&seq=app-download-phone-01&orientation=portrait"
                alt="91影视看片app下载页面"
                className="w-full h-full object-contain object-top"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}